import React, { Component } from 'react'
import { translate } from 'react-i18next'
import { compose } from 'react-apollo'

import { TextInput, RadioButton } from '../../UI'
import DropInComponent from '../../payment/DropInComponent/DropInComponent';

class ReviewPay extends Component {
  constructor(props) {
    super(props)
    this.state = {}
    this.handleFormChange = this.handleFormChange.bind(this)
  }

  componentWillReceiveProps(nextProps) {
    this.setState(nextProps.currentState)
  }

  onTypeChoice(event) {
    this.setState(
      {
        paymentType: event.target.value
      },
      () => this.props.updateState(this.state)
    )
  }

  handleFormChange(event) {
    let name = event.target.name
    this.setState(
      {
        [name]: event.target.value
      },
      () => this.props.updateState(this.state)
    )
  }

  handleNext = () => {
    // Go to success page?
    this.props.history.push(`/`)
  }

  render() {
    const { t, saveBookingSteps } = this.props
    return (
      <div className="payments">
      <DropInComponent
        amount={this.props.amountToPay}
        handlePostPayment={this.handleNext}
        completeTransaction={this.props.saveBookingSteps}
      />
    </div>
    )
  }
}

const enhance = compose(translate('activity_booking_steps'))

export default enhance(ReviewPay)



// WEBPACK FOOTER //
// src/components/Activity/Steps/ReviewPay.jsx